import { Dayjs } from 'dayjs';
import moment from 'moment-timezone';

const getRequiredLabel = (index: any): string => {
    switch (index) {
        case 15:
            return '3';
        case 18:
            return '6';
        case 21:
            return '9';
        case 24:
            return '0';

        default:
            return String(index);
    }
};

const isPresentInSameWeek = (dayA: Dayjs, dayB: Dayjs | null | undefined): any => {
    if (dayB === null) {
        return false;
    }

    return dayA.isSame(dayB, 'week');
};

const getOverlappingCount = (events: any[], timezone: string): number => {
    let maxOverlap = 0;

    events?.forEach((event: any, index: number) => {
        const eventStart = moment.tz(event?.schedules?.[0], timezone);
        const eventEnd = moment.tz(event?.actionEndTime, timezone);

        const eventStartMin = eventStart.hours() * 60 + eventStart.minutes();
        const eventEndMin = eventEnd.hours() * 60 + eventEnd.minutes();

        let overlapCount = 0;

        events?.forEach((otherEvent: any, otherIndex: number) => {
            if (index === otherIndex) return;

            const otherStart = moment.tz(otherEvent?.schedules?.[0], timezone);
            const otherEnd = moment.tz(otherEvent?.actionEndTime, timezone);

            const otherStartMin = otherStart.hours() * 60 + otherStart.minutes();
            const otherEndMin = otherEnd.hours() * 60 + otherEnd.minutes();

            const isOverlapping = otherStartMin < eventEndMin && otherEndMin > eventStartMin;

            if (isOverlapping) overlapCount++;
        });

        maxOverlap = Math.max(maxOverlap, overlapCount);
    });

    return maxOverlap;
};

const getOverlappingEvents = (events: any[], timezone: string): any[] => {
    const overlappedEvents: any[] = [];

    events?.forEach((event: any, index: number) => {
        const eventStart = moment.tz(event?.schedules?.[0], timezone);
        const eventEnd = moment.tz(event?.actionEndTime, timezone);

        const eventStartMinutes = eventStart.hours() * 60 + eventStart.minutes();
        const eventEndMinutes = eventEnd.hours() * 60 + eventEnd.minutes();

        const overlaps = events.filter((otherEvent: any, otherIndex: number) => {
            if (index === otherIndex) return false;

            const otherStart = moment.tz(otherEvent?.schedules?.[0], timezone);
            const otherEnd = moment.tz(otherEvent?.actionEndTime, timezone);

            const otherStartMinutes = otherStart.hours() * 60 + otherStart.minutes();
            const otherEndMinutes = otherEnd.hours() * 60 + otherEnd.minutes();

            const withinThreeHours = Math.abs(otherStartMinutes - eventStartMinutes) <= 180;

            const isOverlap =
                (otherStartMinutes < eventEndMinutes && otherEndMinutes > eventStartMinutes) ||
                (otherStartMinutes >= eventStartMinutes && otherStartMinutes <= eventEndMinutes) ||
                (otherEndMinutes >= eventStartMinutes && otherEndMinutes <= eventEndMinutes);

            return withinThreeHours || isOverlap;
        });

        const alreadyIncluded = overlappedEvents.find((item) => item?.id === event?.id);

        if (!alreadyIncluded && overlaps?.length) {
            overlaps.forEach((item: any, idx: number) => {
                overlappedEvents.push({ ...item, top: 30 * (idx + 1) });
            });
        }
    });

    return overlappedEvents;
};

export { getRequiredLabel, isPresentInSameWeek, getOverlappingCount, getOverlappingEvents };
